import { Hero } from '@/components/astro/new-design-25/ui/Hero';
import { useFreePlan } from '@/hooks/use-free-plan-availability';
import * as m from '@/paraglide/messages';
import { HeroVoices } from './subcomponents/HeroVoices';

/**
 * The hero CTA is a plain `<CtaButton>`: its destination comes from whatever
 * `CtaButtonContext` the page provides, so `homepage-cta-funnel-v1` retargets
 * it from `homepage-25-body.tsx` along with every other CTA on the page.
 */
export function HomepageHero() {
  const { isInFreePlanCountry } = useFreePlan();

  return (
    <Hero
      title={m.homepage_hero_title()}
      description={m.homepage_hero_description()}
      buttonLabel={
        isInFreePlanCountry ? m.homepage_hero_cta_free() : m.homepage_hero_cta()
      }
    >
      <HeroVoices />
    </Hero>
  );
}
